export const CTBrainTemplate = `<div class="card">
<div class="card-body">
     <div id="reportType" style="margin-top: 10px">
     <input id="report-plain" name="report-type" value="plain" type="radio" style="margin-left: 10px;" checked=""> <label id="plain" style="padding-left: 5px;"> Plain</label> <input id="report-contrast" name="report-type" value="contrast" type="radio" style="margin-left: 10px;"> <label id="contrast" style="padding-left: 5px; margin-right: 10px;">Contrast</label>
     </div>
     <div id="tabs">
   <ul class="tab-links" style="font-weight:bold;font-size: 14px;">
      <li class="active">
         <a class="CTBrainTabsColour"  href="#home">Bleed</a>
      </li>
      <li>
         <a class="CTBrainTabsColour"  href="#menu1">Infarcts</a>
      </li>
      <li>
         <a class="CTBrainTabsColour"  href="#menu2">Atrophy</a>
      </li>
      <li>
         <a class="CTBrainTabsColour"  href="#menu3">Others</a>
      </li>
   </ul>
</div>
   <div class="tab-content" style="height: 72vh;overflow:auto">
      <div id="home" class="tab active">
         <h3>Bleed</h3>
         <div id="tabs1">
         <ul class="tab-links" style="font-weight:bold;font-size: 14px;">
            <li class="active">
               <a class="CTBrainTabsColour" href="#rightBleed">Right</a>
            </li>
            <li>
               <a class="CTBrainTabsColour" href="#leftBleed">Left</a>
            </li>
         </ul>
        </div>
         <div class="tab-content">
            <div id="rightBleed" class="tab1 active">
               <table class=" table" style="overflow-y: auto;">
                  <tbody><tr>
                     <td style="padding: 5px 5px 5px 15px" id="bleed-right-small">small</td>
                     <td>
                        <select name="multiSelectReportOptions-bleed-right-small" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-bleed-right-small" multiple="multiple">
                           <option value="basal ganglia">Basal Ganglia</option>
                           <option value="lentiform nucleus">Lentiform Nucleus</option>
                           <option value="caudate nucleus">Caudate Nucleus</option>
                           <option value="anterior limb of internal capsule">Anterior Limb of Internal Capsule</option>
                           <option value="genu">Genu</option>
                           <option value="posterior limb of internal capsule">Posterior Limb of Internal Capsule</option>
                           <option value="thalamus">Thalamus</option>
                           <option value="periventricular white matter">Periventricular White Matter</option>
                           <option value="forceps minor">Forceps Minor</option>
                           <option value="forceps major">Forceps Major</option>
                           <option value="high parietal white matter">High Parietal White Matter</option>
                           <option value="anterior pons">Anterior Pons</option>
                           <option value="posterior pons">Posterior Pons</option>
                           <option value="midbrain">Midbrain</option>
                           <option value="medulla">Medulla</option>
                        </select>
                     </td>
                  </tr>
                  <tr>
                     <td style="padding: 5px 5px 5px 15px" id="bleed-right-moderate">moderate</td>
                     <td>
                        <select name="multiSelectReportOptions-bleed-right-moderate" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-bleed-right-moderate" multiple="multiple">
                           <option value="basal ganglia">Basal Ganglia</option>
                           <option value="lentiform nucleus">Lentiform Nucleus</option>
                           <option value="caudate nucleus">Caudate Nucleus</option>
                           <option value="anterior limb of internal capsule">Anterior Limb of Internal Capsule</option>
                           <option value="genu">Genu</option>
                           <option value="posterior limb of internal capsule">Posterior Limb of Internal Capsule</option>
                           <option value="thalamus">Thalamus</option>
                           <option value="periventricular white matter">Periventricular White Matter</option>
                           <option value="forceps minor">Forceps Minor</option>
                           <option value="forceps major">Forceps Major</option>
                           <option value="high parietal white matter">High Parietal White Matter</option>
                           <option value="anterior pons">Anterior Pons</option>
                           <option value="posterior pons">Posterior Pons</option>
                           <option value="midbrain">Midbrain</option>
                           <option value="medulla">Medulla</option>
                        </select>
                     </td>
                  </tr>
                  <tr>
                     <td style="padding: 5px 5px 5px 15px">large</td>
                     <td>
                        <select name="multiSelectReportOptions-bleed-right-large" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-bleed-right-large" multiple="multiple">
                           <option value="basal ganglia">Basal Ganglia</option>
                           <option value="lentiform nucleus">Lentiform Nucleus</option>
                           <option value="caudate nucleus">Caudate Nucleus</option>
                           <option value="anterior limb of internal capsule">Anterior Limb of Internal Capsule</option>
                           <option value="genu">genu</option>
                           <option value="posterior limb of internal capsule">Posterior Limb of Internal Capsule</option>
                           <option value="thalamus">Thalamus</option>
                           <option value="periventricular white matter">Periventricular White Matter</option>
                           <option value="forceps minor">Forceps Minor</option>
                           <option value="forceps major">Forceps Major</option>
                           <option value="high parietal white matter">High Parietal White Matter</option>
                           <option value="anterior pons">Anterior Pons</option>
                           <option value="posterior pons">Posterior Pons</option>
                           <option value="midbrain">Midbrain</option>
                           <option value="medulla">Medulla</option>
                        </select>
                     </td>
                  </tr>
                  <tr>
                     <td style="padding: 5px 5px 5px 15px">A <input type="number" value="" min="0" step="1" id="heightSpinner" style="width: 4rem;"> cm X <input type="number" value="" min="0" step="1" id="widthSpinner" style="width: 4rem;"> cm </td>
                     <td>
                        <select name="multiSelectReportOptions-bleed-right-custom" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-bleed-right-custom" multiple="multiple">
                           <option value="basal ganglia">Basal Ganglia</option>
                           <option value="lentiform nucleus">Lentiform Nucleus</option>
                           <option value="caudate nucleus">Caudate Nucleus</option>
                           <option value="anterior limb of internal capsule">Anterior Limb of Internal Capsule</option>
                           <option value="genu">Genu</option>
                           <option value="posterior limb of internal capsule">Posterior Limb of Internal Capsule</option>
                           <option value="thalamus">Thalamus</option>
                           <option value="periventricular white matter">Periventricular White Matter</option>
                           <option value="forceps minor">Forceps Minor</option>
                           <option value="forceps major">Forceps Major</option>
                           <option value="high parietal white matter">High Parietal White Matter</option>
                           <option value="anterior pons">Anterior Pons</option>
                           <option value="posterior pons">Posterior Pons</option>
                           <option value="midbrain">Midbrain</option>
                           <option value="medulla">Medulla</option>
                        </select>
                     </td>
                  </tr>
               </tbody></table>
            </div>
            <div id="leftBleed" class="tab1">
               <table class=" table" style="overflow-y: auto;">
                  <tbody><tr>
                     <td style="padding: 5px 5px 5px 15px">small</td>
                     <td>
                        <select name="multiSelectReportOptions-bleed-left-small" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-bleed-left-small" multiple="multiple">
                           <option value="basal ganglia">Basal Ganglia</option>
                           <option value="lentiform nucleus">Lentiform Nucleus</option>
                           <option value="caudate nucleus">Caudate Nucleus</option>
                           <option value="anterior limb of internal capsule">Anterior Limb of Internal Capsule</option>
                           <option value="genu">Genu</option>
                           <option value="posterior limb of internal capsule">Posterior Limb of Internal Capsule</option>
                           <option value="thalamus">Thalamus</option>
                           <option value="periventricular white matter">Periventricular White Matter</option>
                           <option value="forceps minor">Forceps Minor</option>
                           <option value="forceps major">Forceps Major</option>
                           <option value="high parietal white matter">High Parietal White Matter</option>
                           <option value="anterior pons">Anterior Pons</option>
                           <option value="posterior pons">Posterior Pons</option>
                           <option value="midbrain">Midbrain</option>
                           <option value="medulla">Medulla</option>
                        </select>
                     </td>
                  </tr>
                  <tr>
                     <td style="padding: 5px 5px 5px 15px">moderate</td>
                     <td>
                        <select name="multiSelectReportOptions-bleed-left-moderate" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-bleed-left-moderate" multiple="multiple">
                           <option value="basal ganglia">Basal Ganglia</option>
                           <option value="lentiform nucleus">Lentiform Nucleus</option>
                           <option value="caudate nucleus">Caudate Nucleus</option>
                           <option value="anterior limb of internal capsule">Anterior Limb of Internal Capsule</option>
                           <option value="genu">Genu</option>
                           <option value="posterior limb of internal capsule">Posterior Limb of Internal Capsule</option>
                           <option value="thalamus">Thalamus</option>
                           <option value="periventricular white matter">Periventricular White Matter</option>
                           <option value="forceps minor">Forceps Minor</option>
                           <option value="forceps major">Forceps Major</option>
                           <option value="high parietal white matter">High Parietal White Matter</option>
                           <option value="anterior pons">Anterior Pons</option>
                           <option value="posterior pons">Posterior Pons</option>
                           <option value="midbrain">Midbrain</option>
                           <option value="medulla">Medulla</option>
                        </select>
                     </td>
                  </tr>
                  <tr>
                     <td style="padding: 5px 5px 5px 15px">large</td>
                     <td>
                        <select name="multiSelectReportOptions-bleed-left-large" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-bleed-left-large" multiple="multiple">
                           <option value="basal ganglia">Basal Ganglia</option>
                           <option value="lentiform nucleus">Lentiform Nucleus</option>
                           <option value="caudate nucleus">Caudate Nucleus</option>
                           <option value="anterior limb of internal capsule">Anterior Limb of Internal Capsule</option>
                           <option value="genu">Genu</option>
                           <option value="posterior limb of internal capsule">Posterior Limb of Internal Capsule</option>
                           <option value="thalamus">Thalamus</option>
                           <option value="periventricular white matter">Periventricular White Matter</option>
                           <option value="forceps minor">Forceps Minor</option>
                           <option value="forceps major">Forceps Major</option>
                           <option value="high parietal white matter">High Parietal White Matter</option>
                           <option value="anterior pons">Anterior Pons</option>
                           <option value="posterior pons">Posterior Pons</option>
                           <option value="midbrain">Midbrain</option>
                           <option value="medulla">Medulla</option>
                        </select>
                     </td>
                  </tr>
                  <tr>
                     <td style="padding: 5px 5px 5px 15px">A <input type="number" value="" min="0" step="1" id="heightSpinnerleft" style="width: 4rem;"> cm X <input type="number" value="" min="0" step="1" id="widthSpinnerleft" style="width: 4rem;"> cm </td>
                     <td>
                        <select name="multiSelectReportOptions-bleed-left-custom" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-bleed-left-custom" multiple="multiple">
                           <option value="basal ganglia">Basal Ganglia</option>
                           <option value="lentiform nucleus">Lentiform Nucleus</option>
                           <option value="caudate nucleus">Caudate Nucleus</option>
                           <option value="anterior limb of internal capsule">Anterior Limb of Internal Capsule</option>
                           <option value="genu">Genu</option>
                           <option value="posterior limb of internal capsule">Posterior Limb of Internal Capsule</option>
                           <option value="thalamus">Thalamus</option>
                           <option value="periventricular white matter">Periventricular White Matter</option>
                           <option value="forceps minor">Forceps Minor</option>
                           <option value="forceps major">Forceps Major</option>
                           <option value="high parietal white matter">High Parietal White Matter</option>
                           <option value="anterior pons">Anterior Pons</option>
                           <option value="posterior pons">Posterior Pons</option>
                           <option value="midbrain">Midbrain</option>
                           <option value="medulla">Medulla</option>
                        </select>
                     </td>
                  </tr>
               </tbody></table>
            </div>
         </div>
         <h2>Hemorrhagic contusion</h2>
         <div id="tabs2">
         <ul class="tab-links" style="font-weight:bold;font-size: 14px;">
            <li class="active">
               <a class="CTBrainTabsColour"  href="#rightHemorrhagicContusion">Right</a>
            </li>
            <li>
               <a class="CTBrainTabsColour"  href="#leftHemorrhagicContusion">Left</a>
            </li>
         </ul>
        </div>
         <div class="tab-content">
            <div id="rightHemorrhagicContusion" class="tab2 active">
               <table class=" table" style="overflow-y: auto;">
                  <tbody><tr>
                     <td style="padding: 5px 5px 5px 15px">small</td>
                     <td>
                        <select name="multiSelectReportOptions-hemorrhagic-contusion-right-small" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-hemorrhagic-contusion-right-small" multiple="multiple">
                           <option value="frontal region">Frontal Region</option>
                           <option value="temporal region">Temporal Region</option>
                           <option value="parietal region">Parietal Region</option>
                           <option value="occipital region">Occipital Region</option>
                        </select>
                     </td>
                  </tr>
                  <tr>
                     <td style="padding: 5px 5px 5px 15px">moderate</td>
                     <td>
                        <select name="multiSelectReportOptions-hemorrhagic-contusion-right-moderate" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-hemorrhagic-contusion-right-moderate" multiple="multiple">
                           <option value="frontal region">Frontal Region</option>
                           <option value="temporal region">Temporal Region</option>
                           <option value="parietal region">Parietal Region</option>
                           <option value="occipital region">Occipital Region</option>
                        </select>
                     </td>
                  </tr>
                  <tr>
                     <td style="padding: 5px 5px 5px 15px">large</td>
                     <td>
                        <select name="multiSelectReportOptions-hemorrhagic-contusion-right-large" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-hemorrhagic-contusion-right-large" multiple="multiple">
                           <option value="frontal region">Frontal Region</option>
                           <option value="temporal region">Temporal Region</option>
                           <option value="parietal region">Parietal Region</option>
                           <option value="occipital region">Occipital Region</option>
                        </select>
                     </td>
                  </tr>
                  <tr>
                     <td style="padding: 5px 5px 5px 15px">A <input type="number" value="" min="0" step="1" id="heightSpinnerHCR" style="width: 4rem;"> cm X <input type="number" value="" min="0" step="1" id="widthSpinnerHCR" style="width: 4rem;"> cm </td>
                     <td>
                        <select name="hemorrhagic-contusion-right" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-hemorrhagic-contusion-right-custom" multiple="multiple">
                           <option value="frontal region">Frontal Region</option>
                           <option value="temporal region">Temporal Region</option>
                           <option value="parietal region">Parietal Region</option>
                           <option value="occipital region">Occipital Region</option>
                        </select>
                     </td>
                  </tr>
               </tbody></table>
            </div>
            <div id="leftHemorrhagicContusion" class="tab2">
               <table class=" table" style="overflow-y: auto;">
                  <tbody><tr>
                     <td style="padding: 5px 5px 5px 15px">small</td>
                     <td>
                        <select name="multiSelectReportOptions-hemorrhagic-contusion-left-small" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-hemorrhagic-contusion-left-small" multiple="multiple">
                           <option value="frontal region">Frontal Region</option>
                           <option value="temporal region">Temporal Region</option>
                           <option value="parietal region">Parietal Region</option>
                           <option value="occipital region">Occipital Region</option>
                        </select>
                     </td>
                  </tr>
                  <tr>
                     <td style="padding: 5px 5px 5px 15px">moderate</td>
                     <td>
                        <select name="multiSelectReportOptions-hemorrhagic-contusion-left-moderate" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-hemorrhagic-contusion-left-moderate" multiple="multiple">
                           <option value="frontal region">Frontal Region</option>
                           <option value="temporal region">Temporal Region</option>
                           <option value="parietal region">Parietal Region</option>
                           <option value="occipital region">Occipital Region</option>
                        </select>
                     </td>
                  </tr>
                  <tr>
                     <td style="padding: 5px 5px 5px 15px">large</td>
                     <td>
                        <select name="multiSelectReportOptions-hemorrhagic-contusion-left-large" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-hemorrhagic-contusion-left-large" multiple="multiple">
                           <option value="frontal region">Frontal Region</option>
                           <option value="temporal region">Temporal Region</option>
                           <option value="parietal region">Parietal Region</option>
                           <option value="occipital region">Occipital Region</option>
                        </select>
                     </td>
                  </tr>
                  <tr>
                     <td style="padding: 5px 5px 5px 15px">A <input type="number" value="" min="0" step="1" id="heightSpinnerHCL" style="width: 4rem;"> cm X <input type="number" value="" min="0" step="1" id="widthSpinnerHCL" style="width: 4rem;">  cm </td>
                     <td>
                        <select name="multiSelectReportOptions-hemorrhagic-contusion-left-custom" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-hemorrhagic-contusion-left-custom" multiple="multiple">
                           <option value="frontal region">Frontal Region</option>
                           <option value="temporal region">Temporal Region</option>
                           <option value="parietal region">Parietal Region</option>
                           <option value="occipital region">Occipital Region</option>
                        </select>
                     </td>
                  </tr>
               </tbody></table>
            </div>
         </div>
         <h2>Epidural Hematoma</h2>
         <div id="tabs3">
         <ul class="tab-links" style="font-weight:bold;font-size: 14px;">
            <li class="active">
               <a class="CTBrainTabsColour" href="#rightEpiduralHematoma">Right</a>
            </li>
            <li>
               <a class="CTBrainTabsColour" href="#leftEpiduralHematoma">Left</a>
            </li>
         </ul>
        </div>
         <div class="tab-content">
            <div id="rightEpiduralHematoma" class="tab3 active">
               <table class=" table" style="overflow-y: auto;">
                  <tbody><tr>
                     <td style="padding: 5px 5px 5px 15px">thin</td>
                     <td>
                        <select name="multiSelectReportOptions-epidural-hematoma-right-small" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-epidural-hematoma-right-small" multiple="multiple">
                           <option value="frontal region">Frontal Region</option>
                           <option value="temporal region">Temporal Region</option>
                           <option value="parietal region">Parietal Region</option>
                           <option value="occipital region">Occipital Region</option>
                        </select>
                     </td>
                  </tr>
                  <tr>
                     <td style="padding: 5px 5px 5px 15px">moderate</td>
                     <td>
                        <select name="multiSelectReportOptions-epidural-hematoma-right-moderate" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-epidural-hematoma-right-moderate" multiple="multiple">
                           <option value="frontal region">Frontal Region</option>
                           <option value="temporal region">Temporal Region</option>
                           <option value="parietal region">Parietal Region</option>
                           <option value="occipital region">Occipital Region</option>
                        </select>
                     </td>
                  </tr>
                  <tr>
                     <td style="padding: 5px 5px 5px 15px">large</td>
                     <td>
                        <select name="multiSelectReportOptions-epidural-hematoma-right-large" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-epidural-hematoma-right-large" multiple="multiple">
                           <option value="frontal region">Frontal Region</option>
                           <option value="temporal region">Temporal Region</option>
                           <option value="parietal region">Parietal Region</option>
                           <option value="occipital region">Occipital Region</option>
                        </select>
                     </td>
                  </tr>
                  <tr>
                     <td style="padding: 5px 5px 5px 15px">A <input type="number" value="" min="0" step="1" id="heightSpinnerEHR" style="width: 4rem;"> cm X <input type="number" value="" min="0" step="1" id="widthSpinnerEHR" style="width: 4rem;"> cm  </td>
                     <td>
                        <select name="multiSelectReportOptions-epidural-hematoma-right-custom" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-epidural-hematoma-right-custom" multiple="multiple">
                           <option value="frontal region">Frontal Region</option>
                           <option value="temporal region">Temporal Region</option>
                           <option value="parietal region">Parietal Region</option>
                           <option value="occipital region">Occipital Region</option>
                        </select>
                     </td>
                  </tr>
               </tbody></table>
            </div>
            <div id="leftEpiduralHematoma" class="tab3">
               <table class=" table" style="overflow-y: auto;">
                  <tbody><tr>
                     <td style="padding: 5px 5px 5px 15px">thin</td>
                     <td>
                        <select name="multiSelectReportOptions-epidural-hematoma-left-small" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-epidural-hematoma-left-small" multiple="multiple">
                           <option value="frontal region">Frontal Region</option>
                           <option value="temporal region">Temporal Region</option>
                           <option value="parietal region">Parietal Region</option>
                           <option value="occipital region">Occipital Region</option>
                        </select>
                     </td>
                  </tr>
                  <tr>
                     <td style="padding: 5px 5px 5px 15px">moderate</td>
                     <td>
                        <select name="multiSelectReportOptions-epidural-hematoma-left-moderate" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-epidural-hematoma-left-moderate" multiple="multiple">
                           <option value="frontal region">Frontal Region</option>
                           <option value="temporal region">Temporal Region</option>
                           <option value="parietal region">Parietal Region</option>
                           <option value="occipital region">Occipital Region</option>
                        </select>
                     </td>
                  </tr>
                  <tr>
                     <td style="padding: 5px 5px 5px 15px">large</td>
                     <td>
                        <select name="multiSelectReportOptions-epidural-hematoma-left-large" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-epidural-hematoma-left-large" multiple="multiple">
                           <option value="frontal region">Frontal Region</option>
                           <option value="temporal region">Temporal Region</option>
                           <option value="parietal region">Parietal Region</option>
                           <option value="occipital region">Occipital Region</option>
                        </select>
                     </td>
                  </tr>
                  <tr>
                     <td style="padding: 5px 5px 5px 15px">A <input type="number" value="" min="0" step="1" id="heightSpinnerEHL" style="width: 4rem;"> cm X <input type="number" value="" min="0" step="1" id="widthSpinnerEHL" style="width: 4rem;"> cm </td>
                     <td>
                        <select name="multiSelectReportOptions-epidural-hematoma-left-custom" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-epidural-hematoma-left-custom" multiple="multiple">
                           <option value="frontal region">Frontal Region</option>
                           <option value="temporal region">Temporal Region</option>
                           <option value="parietal region">Parietal Region</option>
                           <option value="occipital region">Occipital Region</option>
                        </select>
                     </td>
                  </tr>
               </tbody></table>
            </div>
         </div>
         <h2>Subdural Hematoma</h2>
         <div id="tabs4">
         <ul class="tab-links" style="font-weight:bold;font-size: 14px;">
            <li class="active">
               <a class="CTBrainTabsColour"  href="#rightSubduralHematoma">Right</a>
            </li>
            <li>
               <a class="CTBrainTabsColour"  href="#leftSubduralHematoma">Left</a>
            </li>
         </ul>
        </div>
         <div class="tab-content">
            <div id="rightSubduralHematoma" class="tab4 active">
               <table class=" table" style="overflow-y: auto;">
                  <tbody><tr>
                     <td style="padding: 5px 5px 5px 15px">thin</td>
                     <td>
                        <select name="multiSelectReportOptions-subdural-hematoma-right-small" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-subdural-hematoma-right-small" multiple="multiple">
                           <option value="frontal region">Frontal Region</option>
                           <option value="temporal region">Temporal Region</option>
                           <option value="parietal region">Parietal Region</option>
                           <option value="occipital region">Occipital Region</option>
                        </select>
                     </td>
                  </tr>
                  <tr>
                     <td style="padding: 5px 5px 5px 15px">moderate</td>
                     <td>
                        <select name="multiSelectReportOptions-subdural-hematoma-right-moderate" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-subdural-hematoma-right-moderate" multiple="multiple">
                           <option value="frontal region">Frontal Region</option>
                           <option value="temporal region">Temporal Region</option>
                           <option value="parietal region">Parietal Region</option>
                           <option value="occipital region">Occipital Region</option>
                        </select>
                     </td>
                  </tr>
                  <tr>
                     <td style="padding: 5px 5px 5px 15px">large</td>
                     <td>
                        <select name="multiSelectReportOptions-subdural-hematoma-right-large" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-subdural-hematoma-right-large" multiple="multiple">
                            <option value="frontal region">Frontal Region</option>
                           <option value="temporal region">Temporal Region</option>
                           <option value="parietal region">Parietal Region</option>
                           <option value="occipital region">Occipital Region</option>
                        </select>
                     </td>
                  </tr>
                  <tr>
                     <td style="padding: 5px 5px 5px 15px">A <input type="number" value="" min="0" step="1" id="heightSpinnerSDHR" style="width: 4rem;"> cm X <input type="number" value="" min="0" step="1" id="widthSpinnerSDHR" style="width: 4rem;"> cm  </td>
                     <td>
                        <select name="multiSelectReportOptions-subdural-hematoma-right-custom" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-subdural-hematoma-right-custom" multiple="multiple">
                            <option value="frontal region">Frontal Region</option>
                           <option value="temporal region">Temporal Region</option>
                           <option value="parietal region">Parietal Region</option>
                           <option value="occipital region">Occipital Region</option>
                        </select>
                     </td>
                  </tr>
               </tbody></table>
            </div>
            <div id="leftSubduralHematoma" class="tab4">
               <table class=" table" style="overflow-y: auto;">
                  <tbody><tr>
                     <td style="padding: 5px 5px 5px 15px">thin</td>
                     <td>
                        <select name="multiSelectReportOptions-subdural-hematoma-left-small" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-subdural-hematoma-left-small" multiple="multiple">
                           <option value="frontal region">Frontal Region</option>
                           <option value="temporal region">Temporal Region</option>
                           <option value="parietal region">Parietal Region</option>
                           <option value="occipital region">Occipital Region</option>
                        </select>
                     </td>
                  </tr>
                  <tr>
                     <td style="padding: 5px 5px 5px 15px">moderate</td>
                     <td>
                        <select name="multiSelectReportOptions-subdural-hematoma-left-moderate" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-subdural-hematoma-left-moderate" multiple="multiple">
                           <option value="frontal region">Frontal Region</option>
                           <option value="temporal region">Temporal Region</option>
                           <option value="parietal region">Parietal Region</option>
                           <option value="occipital region">Occipital Region</option>
                        </select>
                     </td>
                  </tr>
                  <tr>
                     <td style="padding: 5px 5px 5px 15px">large</td>
                     <td>
                        <select name="multiSelectReportOptions-subdural-hematoma-left-large" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-subdural-hematoma-left-large" multiple="multiple">
                           <option value="frontal region">Frontal Region</option>
                           <option value="temporal region">Temporal Region</option>
                           <option value="parietal region">Parietal Region</option>
                           <option value="occipital region">Occipital Region</option>
                        </select>
                     </td>
                  </tr>
                  <tr>
                     <td style="padding: 5px 5px 5px 15px">A <input type="number" value="" min="0" step="1" id="heightSpinnerSDHL" style="width: 4rem;"> cm X <input type="number" value="" min="0" step="1" id="widthSpinnerSDHL" style="width: 4rem;"> cm </td>
                     <td>
                        <select name="multiSelectReportOptions-subdural-hematoma-left-custom" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-subdural-hematoma-left-custom" multiple="multiple">
                          <option value="frontal region">Frontal Region</option>
                           <option value="temporal region">Temporal Region</option>
                           <option value="parietal region">Parietal Region</option>
                           <option value="occipital region">Occipital Region</option>
                        </select>
                     </td>
                  </tr>
               </tbody></table>
            </div>
         </div>

         <table class="table">
             <tbody>
                <tr>
                   <td scope="row" style="width: 200px;">
                      <div id="perilesionalEdema">Perilesional edema </div>
                   </td>
                   <td><input id="perilesional-edema-mild" name="perilesional-edema" value="mild" type="radio" style="margin-left:10px;" checked="">
                      <label id="norm" style="padding-left:5px;"> mild</label>
                      <input id="perilesional-edema-moderate" name="perilesional-edema" value="moderate" type="radio" style="margin-left:10px;">
                      <label id="enlar" style="padding-left:5px;margin-right:10px;"> moderate</label>
                      <input id="perilesional-edema-severe" name="perilesional-edema" value="severe" type="radio" style="margin-left:10px;">
                      <label id="enlar" style="padding-left:5px;"> severe</label>
                   </td>
                </tr>
                <tr>
                   <td scope="row" style="width: 200px;">
                      <div id="mass-effect">Mass effect</div>
                   </td>
                   <td>
                      <div id="massEffect">
                         <input id="mass-effect-mild" name="mass-effect" type="radio" value="mild" style="margin-left:10px;" checked="">
                         <label id="norm1" style="padding-left:5px;"> mild</label>
                         <input id="mass-effect-moderate" name="mass-effect" type="radio" value="moderate" style="margin-left:10px;">
                         <label id="enlar1" style="padding-left:5px;margin-right:10px;"> moderate</label>
                         <input id="mass-effect-severe" name="mass-effect" type="radio" value="severe" style="margin-left:10px;">
                         <label id="enlar1" style="padding-left:5px;"> severe</label>
                      </div>
                   </td>
                </tr>

                <tr>
                 <td scope="row" style="width: 200px;">
                    <div id="sulcalEffacement">Sulcal Effacement</div>
                 </td>
                 <td>
                    <div id="sulcalEffacement">
                       <input id="sulcal-effacement-mild" name="sulcal-effacement" type="radio" value="mild" style="margin-left:10px;" checked="">
                       <label id="norm1" style="padding-left:5px;"> mild</label>
                       <input id="sulcal-effacement-moderate" name="sulcal-effacement" type="radio" value="moderate" style="margin-left:10px;">
                       <label id="enlar1" style="padding-left:5px;margin-right:10px;"> moderate</label>
                       <input id="sulcal-effacement-severe" name="sulcal-effacement" type="radio" value="severe" style="margin-left:10px;">
                       <label id="enlar1" style="padding-left:5px;"> severe</label>
                    </div>
                 </td>
              </tr>
                <tr>
                 <td scope="row" style="width: 200px;">
                    <div id="midlineShift">Midline shift </div>
                 </td>
                 <td>
                    <input id="midline-shift-mild" name="midline-shift" value="mild" type="radio" style="margin-left:10px;" checked="">
                    <label id="norm" style="padding-left:5px;"> mild</label>
                    <input id="midline-shift-moderate" name="midline-shift" value="moderate" type="radio" style="margin-left:10px;">
                    <label id="enlar" style="padding-left:5px;margin-right:10px;"> moderate</label>
                    <input id="midline-shift-severe" name="midline-shift" value="severe" type="radio" style="margin-left:10px;">
                    <label id="enlar" style="padding-left:5px;"> severe</label>
                 </td>
              </tr>
             </tbody>
          </table>

         <h2>Ventricular extension and dilatation</h2>
         <div id="tabs5">
         <ul class="tab-links" style="font-weight:bold;font-size: 14px;">
            <li class="active">
               <a class="CTBrainTabsColour"  href="#ipsilateralBoth">Ipsilateral</a>
            </li>
            <li>
               <a class="CTBrainTabsColour" href="#IpsilateralAndContralateralBoth">Ipsilateral and contralateral</a>
            </li>
         </ul>
        </div>
         <div class="tab-content">
            <div id="ipsilateralBoth" class="tab5 active">
               <input id="ventricular-extension-and-dilation-ipsilateral-no" name="ventricular-extension-and-dilation-ipsilateral" type="radio" value="no" style="margin-left:10px;visibility:hidden;" checked="">
               <label id="norm1" style="padding-left:5px;visibility:hidden;"> no</label>
               <input id="ventricular-extension-and-dilation-ipsilateral-mild" name="ventricular-extension-and-dilation-ipsilateral" type="radio" value="mild" style="margin-left:10px;">
               <label id="enlar1" style="padding-left:5px;margin-right:10px;"> mild</label>
               <input id="ventricular-extension-and-dilation-ipsilateral-moderate" name="ventricular-extension-and-dilation-ipsilateral" type="radio" value="moderate" style="margin-left:10px;">
               <label id="enlar2" style="padding-left:5px;margin-right:10px;"> moderate</label>
               <input id="ventricular-extension-and-dilation-ipsilateral-severe" name="ventricular-extension-and-dilation-ipsilateral" type="radio" value="severe" style="margin-left:10px;">
               <label id="enlar3" style="padding-left:5px;margin-right:10px;"> severe</label>
            </div>
            <div id="IpsilateralAndContralateralBoth" class="tab5">
               <input id="ventricular-extension-and-dilation-ipsilateral-contralateral-no" name="ventricular-extension-and-dilation-ipsilateral-and-contralateral" type="radio" value="no" style="margin-left:10px;visibility:hidden;" checked="">
               <label id="norm1" style="padding-left:5px;visibility:hidden;"> no</label>
               <input id="ventricular-extension-and-dilation-ipsilateral-contralateral-mild" name="ventricular-extension-and-dilation-ipsilateral-and-contralateral" type="radio" value="mild" style="margin-left:10px;">
               <label id="enlar1" style="padding-left:5px;margin-right:10px;"> mild</label>
               <input id="ventricular-extension-and-dilation-ipsilateral-contralateral-moderate" name="ventricular-extension-and-dilation-ipsilateral-and-contralateral" type="radio" value="moderate" style="margin-left:10px;">
               <label id="enlar2" style="padding-left:5px;margin-right:10px;"> moderate</label>
               <input id="ventricular-extension-and-dilation-ipsilateral-contralateral-severe" name="ventricular-extension-and-dilation-ipsilateral-and-contralateral" type="radio" value="severe" style="margin-left:10px;">
               <label id="enlar3" style="padding-left:5px;margin-right:10px;"> severe</label>
            </div>
         </div>
         <h2>Ventricular extension without dilatation</h2>
         <div id="tabs6">  
         <ul class="tab-links" style="font-weight:bold;font-size: 14px;">
            <li class="active">
               <a class="CTBrainTabsColour"  href="#ipsilateralWithout">Ipsilateral</a>
            </li>
            <li>
               <a class="CTBrainTabsColour" href="#IpsilateralAndContralateralWithout">Ipsilateral and contralateral</a>
            </li>
         </ul>
        </div>
         <div class="tab-content">
            <div id="ipsilateralWithout" class="tab6 active">
               <input id="ventricular-extension-without-dilation-ipsilateral-no" name="ventricular-extension-without-dilation-ipsilateral" type="radio" value="no" style="margin-left:10px;visibility:hidden;" checked="">
               <label id="norm1" style="padding-left:5px;visibility:hidden;"> no</label>
               <input id="ventricular-extension-without-dilation-ipsilateral-mild" name="ventricular-extension-without-dilation-ipsilateral" type="radio" value="mild" style="margin-left:10px;">
               <label id="enlar1" style="padding-left:5px;margin-right:10px;"> mild</label>
               <input id="ventricular-extension-without-dilation-ipsilateral-moderate" name="ventricular-extension-without-dilation-ipsilateral" type="radio" value="moderate" style="margin-left:10px;">
               <label id="enlar2" style="padding-left:5px;margin-right:10px;"> moderate</label>
               <input id="ventricular-extension-without-dilation-ipsilateral-severe" name="ventricular-extension-without-dilation-ipsilateral" type="radio" value="severe" style="margin-left:10px;">
               <label id="enlar3" style="padding-left:5px;margin-right:10px;"> severe</label>
            </div>
            <div id="IpsilateralAndContralateralWithout" class="tab6 fade">
               <input id="ventricular-extension-without-dilation-ipsilateral-contralateral-no" name="ventricular-extension-without-dilation-ipsilateral-and-contralateral" type="radio" value="no" style="margin-left:10px;visibility:hidden;" checked="">
               <label id="norm1" style="padding-left:5px;visibility:hidden;"> no</label>
               <input id="ventricular-extension-without-dilation-ipsilateral-contralateral--mild" name="ventricular-extension-without-dilation-ipsilateral-and-contralateral" type="radio" value="mild" style="margin-left:10px;">
               <label id="enlar1" style="padding-left:5px;margin-right:10px;"> mild</label>
               <input id="ventricular-extension-without-dilation-ipsilateral-contralateral-moderate" name="ventricular-extension-without-dilation-ipsilateral-and-contralateral" type="radio" value="moderate" style="margin-left:10px;">
               <label id="enlar2" style="padding-left:5px;margin-right:10px;"> moderate</label>
               <input id="ventricular-extension-without-dilation-ipsilateral-contralateral-severe" name="ventricular-extension-without-dilation-ipsilateral-and-contralateral" type="radio" value="severe" style="margin-left:10px;">
               <label id="enlar3" style="padding-left:5px;margin-right:10px;"> severe</label>
            </div>
         </div>
      </div>
      <div id="menu1" class="tab">
         <h3>Infarcts</h3>
         <div id="tabs7">

         
         <ul class="tab-links" style="font-weight:bold;font-size: 14px;">
             <li class="active">
                <a class="CTBrainTabsColour"  href="#rightFocalMultiple">Right</a>
             </li>
             <li>
                <a class="CTBrainTabsColour"  href="#leftFocalMultiple">Left</a>
             </li>
          </ul>
        </div>
         <div class="tab-content">
            <div id="rightFocalMultiple" class="tab7 active">
           
               <table class=" table" style="overflow-y: auto;">
                 <tbody><tr>
                    <td style="padding: 5px 5px 5px 15px;width:200px;" id="infarct-right-focal">Focal</td>
                    <td>
                       <select name="multiSelectReportOptions-infarcts-right-focal" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-infarcts-right-focal" multiple="multiple">
                           <option value="basal ganglia">Basal Ganglia</option>
                           <option value="lentiform nucleus">Lentiform Nucleus</option>
                           <option value="caudate nucleus">Caudate Nucleus</option>
                           <option value="anterior limb of internal capsule">Anterior Limb of Internal Capsule</option>
                           <option value="genu">Genu</option>
                           <option value="posterior limb of internal capsule">Posterior Limb of Internal Capsule</option>
                           <option value="thalamus">Thalamus</option>
                           <option value="periventricular white matter">Periventricular White Matter</option>
                           <option value="forceps minor">Forceps Minor</option>
                           <option value="forceps major">Forceps Major</option>
                           <option value="high parietal white matter">High Parietal White Matter</option>
                           <option value="anterior pons">Anterior Pons</option>
                           <option value="posterior pons">Posterior Pons</option>
                           <option value="midbrain">Midbrain</option>
                           <option value="medulla">Medulla</option>
                       </select>
                    </td>
                 </tr>
                 <tr>
                    <td style="padding: 5px 5px 5px 15px;width:200px;" id="infarct-right-multiple-lacunar">Multiple Lacunar</td>
                    <td>
                       <select name="multiSelectReportOptions-infarcts-right-multiple-lacunar" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-infarcts-right-multiple-lacunar" multiple="multiple">
                           <option value="basal ganglia">Basal Ganglia</option>
                           <option value="lentiform nucleus">Lentiform Nucleus</option>
                           <option value="caudate nucleus">Caudate Nucleus</option>
                           <option value="anterior limb of internal capsule">Anterior Limb of Internal Capsule</option>
                           <option value="genu">Genu</option>
                           <option value="posterior limb of internal capsule">Posterior Limb of Internal Capsule</option>
                           <option value="thalamus">Thalamus</option>
                           <option value="periventricular white matter">Periventricular White Matter</option>
                           <option value="forceps minor">Forceps Minor</option>
                           <option value="forceps major">Forceps Major</option>
                           <option value="high parietal white matter">High Parietal White Matter</option>
                           <option value="anterior pons">Anterior Pons</option>
                           <option value="posterior pons">Posterior Pons</option>
                           <option value="midbrain">Midbrain</option>
                           <option value="medulla">Medulla</option>
                       </select>
                    </td>
                 </tr>
              </tbody></table>
            </div>


            <div id="leftFocalMultiple" class="tab7">
           
             <table class=" table" style="overflow-y: auto;">
               <tbody><tr>
                  <td style="padding: 5px 5px 5px 15px;width:200px;" id="infarct-left-focal">Focal</td>
                  <td>
                     <select name="multiSelectReportOptions-infarcts-left-focal" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-infarcts-left-focal" multiple="multiple">
                         <option value="basal ganglia">Basal Ganglia</option>
                           <option value="lentiform nucleus">Lentiform Nucleus</option>
                           <option value="caudate nucleus">Caudate Nucleus</option>
                           <option value="anterior limb of internal capsule">Anterior Limb of Internal Capsule</option>
                           <option value="genu">Genu</option>
                           <option value="posterior limb of internal capsule">Posterior Limb of Internal Capsule</option>
                           <option value="thalamus">Thalamus</option>
                           <option value="periventricular white matter">Periventricular White Matter</option>
                           <option value="forceps minor">Forceps Minor</option>
                           <option value="forceps major">Forceps Major</option>
                           <option value="high parietal white matter">High Parietal White Matter</option>
                           <option value="anterior pons">Anterior Pons</option>
                           <option value="posterior pons">Posterior Pons</option>
                           <option value="midbrain">Midbrain</option>
                           <option value="medulla">Medulla</option>
                     </select>
                  </td>
               </tr>
               <tr>
                  <td style="padding: 5px 5px 5px 15px;width:200px;" id="infarct-left-multiple-lacunar">Multiple Lacunar</td>
                  <td>
                     <select name="multiSelectReportOptions-infarcts-left-multiple-lacunar" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-infarcts-left-multiple-lacunar" multiple="multiple">
                         <option value="basal ganglia">Basal Ganglia</option>
                           <option value="lentiform nucleus">Lentiform Nucleus</option>
                           <option value="caudate nucleus">Caudate Nucleus</option>
                           <option value="anterior limb of internal capsule">Anterior Limb of Internal Capsule</option>
                           <option value="genu">Genu</option>
                           <option value="posterior limb of internal capsule">Posterior Limb of Internal Capsule</option>
                           <option value="thalamus">Thalamus</option>
                           <option value="periventricular white matter">Periventricular White Matter</option>
                           <option value="forceps minor">Forceps Minor</option>
                           <option value="forceps major">Forceps Major</option>
                           <option value="high parietal white matter">High Parietal White Matter</option>
                           <option value="anterior pons">Anterior Pons</option>
                           <option value="posterior pons">Posterior Pons</option>
                           <option value="midbrain">Midbrain</option>
                           <option value="medulla">Medulla</option>
                     </select>
                  </td>
               </tr>
            </tbody></table>
          </div>
         </div>
         <div id="tabs8">
            <ul class="tab-links" style="font-weight:bold;font-size: 14px;">
                <li class="active">
                   <a class="CTBrainTabsColour"  href="#rightAcuteSubacuteChronicGliosis">Right</a>
                </li>
                <li>
                   <a class="CTBrainTabsColour"  href="#leftAcuteSubacuteChronicGliosis">Left</a>
                </li>
             </ul>
         </div>
         
         <div class="tab-content">
             <div id="rightAcuteSubacuteChronicGliosis" class="tab8 active">
           
                 <table class=" table" style="overflow-y: auto;">
                   <tbody><tr>
                      <td style="padding: 5px 5px 5px 15px;width:200px;" id="infarct-right-acute">Acute</td>
                      <td>
                         <select name="multiSelectReportOptions-infarcts-right-acute" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-infarcts-right-acute" multiple="multiple">
                              <option value="basal ganglia">Basal Ganglia</option>
                           <option value="lentiform nucleus">Lentiform Nucleus</option>
                           <option value="caudate nucleus">Caudate Nucleus</option>
                           <option value="anterior limb of internal capsule">Anterior Limb of Internal Capsule</option>
                           <option value="genu">Genu</option>
                           <option value="posterior limb of internal capsule">Posterior Limb of Internal Capsule</option>
                           <option value="thalamus">Thalamus</option>
                           <option value="periventricular white matter">Periventricular White Matter</option>
                           <option value="forceps minor">Forceps Minor</option>
                           <option value="forceps major">Forceps Major</option>
                           <option value="high parietal white matter">High Parietal White Matter</option>
                           <option value="anterior pons">Anterior Pons</option>
                           <option value="posterior pons">Posterior Pons</option>
                           <option value="midbrain">Midbrain</option>
                           <option value="medulla">Medulla</option>
                         </select>
                      </td>
                   </tr>
                   <tr>
                      <td style="padding: 5px 5px 5px 15px;width:200px;" id="infarct-right-subacute">Subacute</td>
                      <td>
                         <select name="multiSelectReportOptions-infarcts-right-subacute" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-infarcts-right-subacute" multiple="multiple">
                             <option value="basal ganglia">Basal Ganglia</option>
                           <option value="lentiform nucleus">Lentiform Nucleus</option>
                           <option value="caudate nucleus">Caudate Nucleus</option>
                           <option value="anterior limb of internal capsule">Anterior Limb of Internal Capsule</option>
                           <option value="genu">Genu</option>
                           <option value="posterior limb of internal capsule">Posterior Limb of Internal Capsule</option>
                           <option value="thalamus">Thalamus</option>
                           <option value="periventricular white matter">Periventricular White Matter</option>
                           <option value="forceps minor">Forceps Minor</option>
                           <option value="forceps major">Forceps Major</option>
                           <option value="high parietal white matter">High Parietal White Matter</option>
                           <option value="anterior pons">Anterior Pons</option>
                           <option value="posterior pons">Posterior Pons</option>
                           <option value="midbrain">Midbrain</option>
                           <option value="medulla">Medulla</option>
                         </select>
                      </td>
                   </tr>
                   <tr>
                      <td style="padding: 5px 5px 5px 15px;width:200px;" id="infarct-right-chronic-gliosis">Chronic with<br> areas of gliosis</td>
                      <td>
                         <select name="multiSelectReportOptions-infarcts-right-chronic-gliosis" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-infarcts-right-chronic-gliosis" multiple="multiple">
                             <option value="basal ganglia">Basal Ganglia</option>
                           <option value="lentiform nucleus">Lentiform Nucleus</option>
                           <option value="caudate nucleus">Caudate Nucleus</option>
                           <option value="anterior limb of internal capsule">Anterior Limb of Internal Capsule</option>
                           <option value="genu">Genu</option>
                           <option value="posterior limb of internal capsule">Posterior Limb of Internal Capsule</option>
                           <option value="thalamus">Thalamus</option>
                           <option value="periventricular white matter">Periventricular White Matter</option>
                           <option value="forceps minor">Forceps Minor</option>
                           <option value="forceps major">Forceps Major</option>
                           <option value="high parietal white matter">High Parietal White Matter</option>
                           <option value="anterior pons">Anterior Pons</option>
                           <option value="posterior pons">Posterior Pons</option>
                           <option value="midbrain">Midbrain</option>
                           <option value="medulla">Medulla</option>
                         </select>
                      </td>
                   </tr>
                </tbody></table>
              </div>
             
              <div id="leftAcuteSubacuteChronicGliosis" class="tab8">
           
                 <table class=" table" style="overflow-y: auto;">
                   <tbody><tr>
                      <td style="padding: 5px 5px 5px 15px;width:200px;" id="infarct-left-acute">Acute</td>
                      <td>
                         <select name="multiSelectReportOptions-infarcts-left-acute" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-infarcts-left-acute" multiple="multiple">
                              <option value="basal ganglia">Basal Ganglia</option>
                           <option value="lentiform nucleus">Lentiform Nucleus</option>
                           <option value="caudate nucleus">Caudate Nucleus</option>
                           <option value="anterior limb of internal capsule">Anterior Limb of Internal Capsule</option>
                           <option value="genu">Genu</option>
                           <option value="posterior limb of internal capsule">Posterior Limb of Internal Capsule</option>
                           <option value="thalamus">Thalamus</option>
                           <option value="periventricular white matter">Periventricular White Matter</option>
                           <option value="forceps minor">Forceps Minor</option>
                           <option value="forceps major">Forceps Major</option>
                           <option value="high parietal white matter">High Parietal White Matter</option>
                           <option value="anterior pons">Anterior Pons</option>
                           <option value="posterior pons">Posterior Pons</option>
                           <option value="midbrain">Midbrain</option>
                           <option value="medulla">Medulla</option>
                         </select>
                      </td>
                   </tr>
                   <tr>
                      <td style="padding: 5px 5px 5px 15px;width:200px;" id="infarct-left-subacute">Subacute</td>
                      <td>
                         <select name="multiSelectReportOptions-infarcts-left-subacute" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-infarcts-left-subacute" multiple="multiple">
                             <option value="basal ganglia">Basal Ganglia</option>
                           <option value="lentiform nucleus">Lentiform Nucleus</option>
                           <option value="caudate nucleus">Caudate Nucleus</option>
                           <option value="anterior limb of internal capsule">Anterior Limb of Internal Capsule</option>
                           <option value="genu">Genu</option>
                           <option value="posterior limb of internal capsule">Posterior Limb of Internal Capsule</option>
                           <option value="thalamus">Thalamus</option>
                           <option value="periventricular white matter">Periventricular White Matter</option>
                           <option value="forceps minor">Forceps Minor</option>
                           <option value="forceps major">Forceps Major</option>
                           <option value="high parietal white matter">High Parietal White Matter</option>
                           <option value="anterior pons">Anterior Pons</option>
                           <option value="posterior pons">Posterior Pons</option>
                           <option value="midbrain">Midbrain</option>
                           <option value="medulla">Medulla</option>
                         </select>
                      </td>
                   </tr>
                   <tr>
                      <td style="padding: 5px 5px 5px 15px;width:200px;" id="infarct-left-chronic-gliosis">Chronic with <br>areas of gliosis</td>
                      <td>
                         <select name="multiSelectReportOptions-infarcts-left-chronic-gliosis" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-infarcts-left-chronic-gliosis" multiple="multiple">
                              <option value="basal ganglia">Basal Ganglia</option>
                           <option value="lentiform nucleus">Lentiform Nucleus</option>
                           <option value="caudate nucleus">Caudate Nucleus</option>
                           <option value="anterior limb of internal capsule">Anterior Limb of Internal Capsule</option>
                           <option value="genu">Genu</option>
                           <option value="posterior limb of internal capsule">Posterior Limb of Internal Capsule</option>
                           <option value="thalamus">Thalamus</option>
                           <option value="periventricular white matter">Periventricular White Matter</option>
                           <option value="forceps minor">Forceps Minor</option>
                           <option value="forceps major">Forceps Major</option>
                           <option value="high parietal white matter">High Parietal White Matter</option>
                           <option value="anterior pons">Anterior Pons</option>
                           <option value="posterior pons">Posterior Pons</option>
                           <option value="midbrain">Midbrain</option>
                           <option value="medulla">Medulla</option>
                         </select>
                      </td>
                   </tr>
                </tbody></table>
              </div>

         </div>
         <div id="tabs9">
            <ul class="tab-links" style="font-weight:bold;font-size: 14px;">
                <li class="active">
                   <a class="CTBrainTabsColour"  href="#rightHypodenseWedgeShape">Right</a>
                </li>
                <li>
                   <a class="CTBrainTabsColour"  href="#leftHypodenseWedgeShape">Left</a>
                </li>
             </ul>
         </div>
         
         <div class="tab-content">
            <div id="rightHypodenseWedgeShape" class="tab9 active">
           
               <table class=" table" style="overflow-y: auto;">
                 <tbody><tr>
                    <td style="padding: 5px 5px 5px 15px;width:200px;" id="infarct-right-hypodense-wedge-shaped-small">Hypodense wedge<br> shaped small</td>
                    <td>
                       <select name="multiSelectReportOptions-infarcts-right-hypodense-wedge-shaped-small" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-infarcts-right-hypodense-wedge-shaped-small" multiple="multiple">
                           <option value="basal ganglia">Basal Ganglia</option>
                           <option value="lentiform nucleus">Lentiform Nucleus</option>
                           <option value="caudate nucleus">Caudate Nucleus</option>
                           <option value="anterior limb of internal capsule">Anterior Limb of Internal Capsule</option>
                           <option value="genu">Genu</option>
                           <option value="posterior limb of internal capsule">Posterior Limb of Internal Capsule</option>
                           <option value="thalamus">Thalamus</option>
                           <option value="periventricular white matter">Periventricular White Matter</option>
                           <option value="forceps minor">Forceps Minor</option>
                           <option value="forceps major">Forceps Major</option>
                           <option value="high parietal white matter">High Parietal White Matter</option>
                           <option value="anterior pons">Anterior Pons</option>
                           <option value="posterior pons">Posterior Pons</option>
                           <option value="midbrain">Midbrain</option>
                           <option value="medulla">Medulla</option>
                       </select>
                    </td>
                 </tr>
                 <tr>
                    <td style="padding: 5px 5px 5px 15px;width:200px;" id="infarct-right-hypodense-wedge-shaped-large">Hypodense wedge<br> shaped large</td>
                    <td>
                       <select name="multiSelectReportOptions-infarcts-right-hypodense-wedge-shaped-large" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-infarcts-right-hypodense-wedge-shaped-large" multiple="multiple">
                            <option value="basal ganglia">Basal Ganglia</option>
                           <option value="lentiform nucleus">Lentiform Nucleus</option>
                           <option value="caudate nucleus">Caudate Nucleus</option>
                           <option value="anterior limb of internal capsule">Anterior Limb of Internal Capsule</option>
                           <option value="genu">Genu</option>
                           <option value="posterior limb of internal capsule">Posterior Limb of Internal Capsule</option>
                           <option value="thalamus">Thalamus</option>
                           <option value="periventricular white matter">Periventricular White Matter</option>
                           <option value="forceps minor">Forceps Minor</option>
                           <option value="forceps major">Forceps Major</option>
                           <option value="high parietal white matter">High Parietal White Matter</option>
                           <option value="anterior pons">Anterior Pons</option>
                           <option value="posterior pons">Posterior Pons</option>
                           <option value="midbrain">Midbrain</option>
                           <option value="medulla">Medulla</option>
                       </select>
                    </td>
                 </tr>
              </tbody></table>
            </div>


            <div id="leftHypodenseWedgeShape" class="tab9">
           
             <table class=" table" style="overflow-y: auto;">
               <tbody><tr>
                  <td style="padding: 5px 5px 5px 15px;width:200px;" id="infarct-left-hypodense-wedge-shaped-small">Hypodense wedge<br> shaped small</td>
                  <td>
                     <select name="multiSelectReportOptions-infarcts-left-hypodense-wedge-shaped-small" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-infarcts-left-hypodense-wedge-shaped-small" multiple="multiple">
                          <option value="basal ganglia">Basal Ganglia</option>
                           <option value="lentiform nucleus">Lentiform Nucleus</option>
                           <option value="caudate nucleus">Caudate Nucleus</option>
                           <option value="anterior limb of internal capsule">Anterior Limb of Internal Capsule</option>
                           <option value="genu">Genu</option>
                           <option value="posterior limb of internal capsule">Posterior Limb of Internal Capsule</option>
                           <option value="thalamus">Thalamus</option>
                           <option value="periventricular white matter">Periventricular White Matter</option>
                           <option value="forceps minor">Forceps Minor</option>
                           <option value="forceps major">Forceps Major</option>
                           <option value="high parietal white matter">High Parietal White Matter</option>
                           <option value="anterior pons">Anterior Pons</option>
                           <option value="posterior pons">Posterior Pons</option>
                           <option value="midbrain">Midbrain</option>
                           <option value="medulla">Medulla</option>
                     </select>
                  </td>
               </tr>
               <tr>
                  <td style="padding: 5px 5px 5px 15px;width:200px;" id="infarct-left-hypodense-wedge-shaped-large">Hypodense wedge<br> shaped large</td>
                  <td>
                     <select name="multiSelectReportOptions-infarcts-left-hypodense-wedge-shaped-large" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-infarcts-left-hypodense-wedge-shaped-large" multiple="multiple">
                          <option value="basal ganglia">Basal Ganglia</option>
                           <option value="lentiform nucleus">Lentiform Nucleus</option>
                           <option value="caudate nucleus">Caudate Nucleus</option>
                           <option value="anterior limb of internal capsule">Anterior Limb of Internal Capsule</option>
                           <option value="genu">Genu</option>
                           <option value="posterior limb of internal capsule">Posterior Limb of Internal Capsule</option>
                           <option value="thalamus">Thalamus</option>
                           <option value="periventricular white matter">Periventricular White Matter</option>
                           <option value="forceps minor">Forceps Minor</option>
                           <option value="forceps major">Forceps Major</option>
                           <option value="high parietal white matter">High Parietal White Matter</option>
                           <option value="anterior pons">Anterior Pons</option>
                           <option value="posterior pons">Posterior Pons</option>
                           <option value="midbrain">Midbrain</option>
                           <option value="medulla">Medulla</option>
                     </select>
                  </td>
               </tr>
            </tbody></table>
          </div>
         </div>

         <table class="table">
            <tbody>
               <tr>
                  <td scope="row" style="width: 200px;">
                     <div id="massEffectInfarcts">Mass Effect </div>
                  </td>
                  <td>
                     <input id="mass-effect-infarcts-no" name="mass-effect-infarcts" type="radio" value="no" style="margin-left:10px;visibility:hidden;" checked="">
                     <label id="norm1" style="padding-left:5px;visibility:hidden;"> no</label>
                     <input id="mass-effect-infarcts-mild" name="mass-effect-infarcts" type="radio" value="mild" style="margin-left:10px;">
                     <label id="enlar1" style="padding-left:5px;"> mild</label>
                     <input id="mass-effect-infarcts-moderate" name="mass-effect-infarcts" type="radio" value="moderate" style="margin-left:10px;">
                     <label id="enlar1" style="padding-left:5px;margin-right:10px;"> moderate</label>
                     <input id="mass-effect-infarcts-severe" name="mass-effect-infarcts" type="radio" value="severe" style="margin-left:10px;">
                     <label id="enlar1" style="padding-left:5px;"> severe</label>
                  </td>
               </tr>
               <tr>
                  <td scope="row" style="width: 200px;">
                     <div id="sulcalEffacementInfarcts">Sulcal Effacement</div>
                  </td>
                  <td>
                     <input id="sulcal-effacements-infarcts-no" name="sulcal-effacements-infarcts" type="radio" value="no" style="margin-left:10px;visibility:hidden;" checked="">
                     <label id="norm1" style="padding-left:5px;visibility:hidden;"> no</label>
                     <input id="sulcal-effacements-infarcts-mild" name="sulcal-effacements-infarcts" type="radio" value="mild" style="margin-left:10px;">
                     <label id="enlar1" style="padding-left:5px;"> mild</label>
                     <input id="sulcal-effacements-infarcts-moderate" name="sulcal-effacements-infarcts" type="radio" value="moderate" style="margin-left:10px;">
                     <label id="enlar1" style="padding-left:5px;margin-right:10px;"> moderate</label>
                     <input id="sulcal-effacements-infarcts-severe" name="sulcal-effacements-infarcts" type="radio" value="severe" style="margin-left:10px;">
                     <label id="enlar1" style="padding-left:5px;"> severe</label>
                  </td>
               </tr>
               <tr>
                  <td scope="row" style="width: 200px;">
                     <div id="midlineShiftInfarcts">Midline Shift</div>
                  </td>
                  <td>
                     <input id="midline-shift-infarcts-no" name="midline-shift-infarcts" type="radio" value="normal" style="margin-left:10px;visibility:hidden;" checked="">
                     <label id="norm1" style="padding-left:5px;visibility:hidden;"> no</label>
                     <input id="midline-shift-infarcts-mild" name="midline-shift-infarcts" type="radio" value="mild" style="margin-left:10px;">
                     <label id="enlar1" style="padding-left:5px;"> mild</label>
                     <input id="midline-shift-infarcts-moderate" name="midline-shift-infarcts" type="radio" value="moderate" style="margin-left:10px;">
                     <label id="enlar1" style="padding-left:5px;margin-right:10px;"> moderate</label>
                     <input id="midline-shift-infarcts-severe" name="midline-shift-infarcts" type="radio" value="severe" style="margin-left:10px;">
                     <label id="enlar1" style="padding-left:5px;"> severe</label>
                  </td>
               </tr>
            </tbody>
         </table>
      </div>
      <div id="menu2" class="tab">
         <h3>Atrophy</h3>
         <p>Basal cisterns and sulcal spaces</p>
         <table class=" table" style="overflow-y: auto;">
            <tbody><tr>
               <td style="padding: 5px 5px 5px 15px">Normal</td>
               <td>
                  <input id="normal" name="gca" type="radio" value="normal" style="margin-left:10px;">
                  <span>normal</span>
               </td>
               <td>&nbsp;</td>
               <td>&nbsp;</td>
            </tr>
            <tr>
               <td style="padding: 5px 5px 5px 15px">GCA</td>
               <td>
                  <input id="gca-mild" name="gca" type="radio" value="gca-mild" style="margin-left:10px;">
                  <span>mild</span>
               </td>
               <td style="width: 102px;">
                  <input id="gca-moderate" name="gca" type="radio" value="gca-moderate">
                  <span>moderate</span>
               </td>
               <td style="width: 102px;">
                  <input id="gca-severe" name="gca" type="radio" value="gca-severe">
                  <span>severe</span>
               </td>
            </tr>
            <tr>
               <td style="padding: 5px 5px 5px 15px">Inconsistent GCA</td>
               <td style="width: 130px;">
                  <input id="inconsistent-gca" name="nph" type="radio" value="inconsistent-gca" style="margin-left:10px;">
                  <span>inconsistent</span>
               </td>
               <td>&nbsp;</td>
               <td>&nbsp;</td>
            </tr>
            <tr>
               <td style="padding: 5px 5px 5px 15px">NPH</td>
               <td>
                  <input id="nph" name="nph" type="radio" value="nph" style="margin-left:10px;">
                  <span>nph</span>
               </td>
               <td>&nbsp;</td>
               <td>&nbsp;</td>
            </tr>
            <tr>
               <td style="padding: 5px 5px 5px 15px">Communicating Hydrocephalus</td>
               <td>
                  <input id="communicating-hydrocephalus-mild" name="nph" type="radio" value="communicating-hydrocephalus-mild" style="margin-left:10px;">
                  <span>mild</span>
               </td>
               <td>
                  <input id="communicating-hydrocephalus-moderate" name="nph" type="radio" value="communicating-hydrocephalus-moderate">
                  <span>moderate</span>
               </td>
               <td>
                  <input id="communicating-hydrocephalus-severe" name="nph" type="radio" value="communicating-hydrocephalus-severe">
                  <span>severe</span>
               </td>
            </tr>
            <tr>
               <td style="padding: 5px 5px 5px 15px">Non-communicating Hydrocephalus</td>
               <td>
                  <input id="non-communicating-hydrocephalus" name="gce" type="radio" value="non-communicating-hydrocephalus" style="margin-left:10px;">
                  <span>non</span>
               </td>
               <td>&nbsp;</td>
               <td>&nbsp;</td>
            </tr>
            <tr>
               <td style="padding: 5px 5px 5px 15px">GCE</td>
               <td>
                  <input id="gce-mild" name="gce" type="radio" value="gce-mild" style="margin-left:10px;">
                  <span>mild</span>
               </td>
               <td>
                  <input id="gce-moderate" name="gce" type="radio" value="gce-moderate">
                  <span>moderate</span>
               </td>
               <td>
                  <input id="gce-severe" name="gce" type="radio" value="gce-severe">
                  <span>severe</span>
               </td>
            </tr>
         </tbody></table>
      </div>
      <div id="menu3" class="tab">
         <h3>Others</h3>
         <div id="neuro-degenerative-calcification">
                  </div><div id="cardiac">
                  </div><div id="cardiac">
                  </div><div id="othersfracture">
                  </div><div id="mucosal-thickening">
                  </div><div id="fluid-levels">
                  </div><div id="polyp">
                  </div><table class=" table" style="overflow-y: auto;">
            <tbody><tr style="display:none;">
               <td><span>The ventricular structures are normal</span></td>
               <td>
                  <div id="ventricular-normal-others">
                     <input id="others-ventricular-yes" name="others-ventricular" type="radio" value="yes" style="margin-left:10px;" checked="">
                     <label id="norm2" style="padding-left:5px;"> yes</label>
                     <input id="others-ventricular-no" name="others-ventricular" type="radio" value="no" style="margin-left:10px;">
                     <label id="enlar3" style="padding-left:5px;margin-right:10px;"> no </label>
                  </div>
               </td>
            </tr>
            <tr>
               <td> <span>Neurodegenerative calcification in the</span> </td>
                  <td>
                     <span>
                        <select name="multiSelectReportOptions-neuro-degenerative-calcification" style="width:260px;" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-neuro-degenerative-calcification" multiple="multiple">
                           <option value="basal ganglia">Basal Ganglia</option>
                           <option value="thalamus">Thalamus</option>
                           <option value="periventricular white matter">Periventricular White Matter</option>
                           <option value="cerebellar hemisphere">Cerebellar Hemisphere</option>
                           <option value="high parietal region">High Parietal Region</option>
                           <option value="anterior limb of internal capsule">Anterior Limb of Internal Capsule</option>
                           <option value="genu">Genu</option>
                           <option value="posterior limb of internal capsule">Posterior Limb of Internal Capsule</option>
                        </select>
                     </span>
                  </td>
               
            </tr>                                       
            <tr style="display:none;">
               <td><span>The osseous structues in the skull base are normal</span></td>
                  <td>
                     <input id="others-osseous-skull-yes" name="others-osseous-skull" type="radio" value="yes" style="margin-left:10px;" checked="">
                     <label id="norm" style="padding-left:5px;"> yes</label>
                     <input id="others-osseous-skull-no" name="others-osseous-skull" type="radio" value="no" style="margin-left:10px;">
                     <label id="enlar" style="padding-left:5px;margin-right:10px;"> no </label>
                  </td>
               
            </tr>
            <tr style="display:none;">
               <td><span>The osseous structures in the calvarium are normal</span></td>
                  <td>
                     <input id="others-osseous-calvarium-yes" name="others-osseous-calvarium" type="radio" value="yes" style="margin-left:10px;" checked="">
                     <label id="norm" style="padding-left:5px;"> yes</label>
                     <input id="others-osseous-calvarium-no" name="others-osseous-calvarium" type="radio" value="no" style="margin-left:10px;">
                     <label id="enlar" style="padding-left:5px;margin-right:10px;"> no </label>
                  </td>
               
            </tr>
            <tr>
               <td><span>Fracture of the</span></td>
                  <td>
                     <span>
                        <select name="multiSelectReportOptions-others-fracture" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-others-fracture" multiple="multiple">
                           <option value="frontal bone">Frontal Bone</option>
                           <option value="parietal bone">Parietal Bone</option>
                           <option value="temporal bone">Temporal Bone</option>
                           <option value="squamous temporal">Squamous Temporal</option>
                           <option value="petrous temporal"> Petrous Temporal</option>
                           <option value="occipital bone">Occipital Bone</option>
                           <option value="base of anterior cranial fossa">Base of Anterior Cranial Fossa</option>
                           <option value="middle cranial fossa">Middle Cranial Fossa</option>
                           <option value="posterior cranial fossa without with extension to foramen magnum"> Posterior Cranial Fossa Without With Extension to Foramen Magnum</option>
                           <option value="medial orbital">Medial Orbital</option>
                           <option value="superior orbital wall">Superior Orbital Wall</option>
                           <option value="posterolateral orbital wall"> Posterolateral Orbital Wall</option>
                           <option value="orbital apex">Orbital Apex</option>
                           <option value="lamina papayrace">Lamina Papayrace</option>
                           <option value="blow out fracture of medial orbital wall">Blow Out Fracture of Medial Orbital Wall</option>
                           <option value="zygomatic arch">Zygomatic Arch</option>
                           <option value="nasal bone">Nasal Bone</option>
                           <option value="hard palate">Hard Palate</option>
                           <option value="anterior, posterior wall maxillary sinus">Anterior, Posterior Wall Maxillary Sinus</option>
                           <option value="pterygoid plates">Pterygoid Plates</option>
                           <option value="nasal septum">Nasal Septum</option>
                           <option value="nasal bone">Nasal Bone</option>
                           <option value="premaxillary region">Premaxillary Region</option>
                           <option value="condyloid process mandible">Condyloid Process Mandible</option>
                           <option value="coronoid prcess of mandible">Coronoid Process of Mandible</option>
                           <option value="angle of mandible">Angle of Mandible</option>
                           <option value="parasymphseal region of mandible on "> Parasymphseal Region of Mandible on </option>
                        </select>
                     </span>
                  </td>
               
            </tr>
            <tr>
               <td> <span>Mucosal thickening is noted</span> </td>
                  <td>
                     <span>
                        <select name="multiSelectReportOptions-mucosal-thickening" style="width:260px;" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-mucosal-thickening" multiple="multiple">
                           <option value="right maxillary">Right Maxillary</option>
                           <option value="left maxillary">Left Maxillary</option>
                           <option value="right anterior ethmoid cells">Right Anterior Ethmoid Cells</option>
                           <option value="right middle ethmoid cells">Right Middle Ethmoid Cells</option>
                           <option value="right posterior ethmoid cells">Right Posterior Ethmoid Cells</option>
                           <option value="left anterior ethmoid cells">Left Anterior Ethmoid Cells</option>
                           <option value="left middle ethmoid cells">Left Middle Ethmoid Cells</option>
                           <option value="left posterior ethmoid cells">Left Posterior Ethmoid Cells</option>
                           <option value="right frontal sinus ethmoid cells">Right Frontal Sinus</option>
                           <option value="left frontal sinus ethmoid cells">Left Frontal Sinus</option>
                           <option value="right side of sphenoid sinus">Right Side of Sphenoid Sinus</option>
                           <option value="left side of sphenoid sinus">Left Side of Sphenoid Sinus</option>
                        </select>
                     </span>
                  </td>
               
            </tr>
            <tr>
               <td> <span>Collection with fluid levels noted in </span> </td>
                  <td>
                     <span>
                        <select name="multiSelectReportOptions-fluid-levels" style="width:260px;" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-fluid-levels" multiple="multiple">
                            <option value="right maxillary">Right Maxillary</option>
                           <option value="left maxillary">Left Maxillary</option>
                           <option value="right anterior ethmoid cells">Right Anterior Ethmoid Cells</option>
                           <option value="right middle ethmoid cells">Right Middle Ethmoid Cells</option>
                           <option value="right posterior ethmoid cells">Right Posterior Ethmoid Cells</option>
                           <option value="left anterior ethmoid cells">Left Anterior Ethmoid Cells</option>
                           <option value="left middle ethmoid cells">Left Middle Ethmoid Cells</option>
                           <option value="left posterior ethmoid cells">Left Posterior Ethmoid Cells</option>
                           <option value="right frontal sinus ethmoid cells">Right Frontal Sinus</option>
                           <option value="left frontal sinus ethmoid cells">Left Frontal Sinus</option>
                           <option value="right side of sphenoid sinus">Right Side of Sphenoid Sinus</option>
                           <option value="left side of sphenoid sinus">Left Side of Sphenoid Sinus</option>
                        </select>
                     </span>
                  </td>
               
            </tr>
            <tr>
               <td> <span>Polyp is noted in</span> </td>
                  <td>
                     <span>
                        <select name="multiSelectReportOptions-others-polyp" style="width:260px;" class="select2-multiple multiSelectReportOptions" id="multiSelectReportOptions-others-polyp" multiple="multiple">
                            <option value="right maxillary">Right Maxillary</option>
                           <option value="left maxillary">Left Maxillary</option>
                           <option value="right anterior ethmoid cells">Right Anterior Ethmoid Cells</option>
                           <option value="right middle ethmoid cells">Right Middle Ethmoid Cells</option>
                           <option value="right posterior ethmoid cells">Right Posterior Ethmoid Cells</option>
                           <option value="left anterior ethmoid cells">Left Anterior Ethmoid Cells</option>
                           <option value="left middle ethmoid cells">Left Middle Ethmoid Cells</option>
                           <option value="left posterior ethmoid cells">Left Posterior Ethmoid Cells</option>
                           <option value="right frontal sinus ethmoid cells">Right Frontal Sinus</option>
                           <option value="left frontal sinus ethmoid cells">Left Frontal Sinus</option>
                           <option value="right side of sphenoid sinus">Right Side of Sphenoid Sinus</option>
                           <option value="left side of sphenoid sinus">Left Side of Sphenoid Sinus</option>
                        </select>
                     </span>
                  </td>
               
            </tr>
         </tbody></table>
      </div>
   </div>
</div>
</div>`;